import actions from '../utils/restActions';
import { customRequest} from '../utils/restUtils';


export const isAuthenticatedRequest = () => {
    return (dispatch) => {
	return customRequest(actions.session.get, {}).then((res) => {
	    return dispatch({ type: actions.session.get.status.success})
	}).catch(() => {return dispatch({ type: actions.session.delete.status.success})})
    }
}

export const login = (data) => {
    return (dispatch) => {
	return customRequest(actions.session.create, data).then((res) => {
	    return dispatch({ type: actions.session.create.status.success});
	})
    }
}

export const logout = () => {
    return (dispatch) => {
	return customRequest(actions.session.delete, {}).then((res) => {
	    return dispatch({ type: actions.session.delete.status.success});
	})
    }
}



// WEBPACK FOOTER //
// ./src/actions/Session.js